module.exports = __webpack_public_path__ + "img/realized-semipublic.5808e086.png";